{
  "title": "Faktaboks",
  "factboxDocument": "Faktaboks dokument",
  "lockedToArticle": "Låst til artikkel",
  "fromPublished": "Låst til publisert",
  "article": "artikkel",
  "original": "original",
  "action": {
    "createFactbox": "Ny faktaboks",
    "open": "Åpne"
  },
  "usedInArticles": "Brukes i artikler",
  "prompts": {
    "approveBeforeClose": "Vil du godkjenne endringene før du lukker?",
    "savedButNotApproved": "Endringene er lagret, men faktaboksen er ikke godkjent."
  }
}
